export type OriginKey = "all" | "client" | "cuisine" | "pos" | "paiement";

export type OriginConfig = {
    enabled: boolean;
    color: string;
};

export type NotificationsState = {
    origins: Record<OriginKey, OriginConfig>;
};

export const DEFAULT_ORIGINS: Record<OriginKey, OriginConfig> = {
    all: { enabled: true, color: "#333333" },
    client: { enabled: true, color: "#FF9800" },
    cuisine: { enabled: true, color: "#4CAF50" },
    pos: { enabled: true, color: "#2196F3" },
    paiement: { enabled: true, color: "#9C27B0" },
};
